import { Injectable } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressBarMode } from '@angular/material/progress-bar';

@Injectable({
  providedIn: 'root'
})

/**
 * The ProgressBarService class is a service that provides a way 
 * to set the mode, color, and active properties 
 * of the progress bar component
 */
export class ProgressBarService {

  private _mode: ProgressBarMode = 'indeterminate';
  private _color: ThemePalette = 'accent';
  private _active: boolean = false;
  private _hasToolbar: boolean = true;
  
  constructor() { console.log('ProgressBarService') }

  /**
   * If the mode is not set, set it to the value of the argument. 
   * Otherwise, return the current value of the mode.
   * @returns The value of the property mode.
   */
  get mode() {
    return this._mode;
  }

  /**
   * It sets the mode of the progress bar.
   * @param {ProgressBarMode} v - The value of the progress bar.
   */
  set mode(v: ProgressBarMode) {
    this._mode = v;
  }

  /**
   * The getter function is called when the property is accessed
   * @returns The color property of the object.
   */
  get color() {
    return this._color;
  }

  /**
   * It sets the color of the button.
   * @param {ThemePalette} v - ThemePalette - The color of the button.
   */
  set color(v: ThemePalette) {
    this._color = v;
  }

  
  /**
   * It returns the value of the private variable _active.
   * @returns The value of the private variable _active.
   */
  public get active() : boolean {
    return this._active;
  }
  

  /**
   * It sets the value of the private variable _active to the value of the parameter v.
   * @param {boolean} v - The value to set the property to.
   */
  public set active(v : boolean) {
    this._active = v;
  }

  /**
   * It sets the value of the private variable _hasToolbar to the value of the parameter v.
   * @param {boolean} v - boolean - the value to set the property to
   */
  set hasToolbar(v: boolean) {
    this._hasToolbar = v;
  }

  /**
   * It returns the value of the private variable _hasToolbar.
   * @returns The value of the _hasToolbar property.
   */
  get hasToolbar() {
    return this._hasToolbar;
  }

  /**
   * The function `show()` sets the `_active` property to `true`
   */
  public show() {
    this._active = true;
  }

  /**
   * The function `hide()` sets the `_active` property to `false`
   */
  public hide() {
    this._active = false;
  }

  /**
   * It toggles the value of the private _active property
   */
  public toggle() {
    this._active = !this._active;
  }

}